export const userRoles = Object.freeze({
  hospital: {
    approver: 'Approver',
  },
  vendor: 'Vendor',
  omiAdmin: 'OMI Admin',
});
